import AudioEngine from '@/webgl/audio/AudioEngine'
import { PlayOptions } from '@/webgl/audio/AudioSource'
import Sound from '@/webgl/audio/Sound'
import Signal from '@/webgl/core/Signal'

class LayerTrack {
  gain: GainNode

  _playingSound: Sound | null = null
  onEnded: Signal<void> = new Signal()

  constructor(
    readonly engine: AudioEngine,
    readonly source: string
  ) {
    this.gain = engine.context.createGain()
  }

  play(opts: PlayOptions): void {
    this._playingSound = this.engine.library.get(this.source).play(opts)
    this._playingSound.gain.disconnect()
    this._playingSound.gain.connect(this.gain)
    this._playingSound.onEnded.on(this.onEnded.emit)
  }

  stop() {
    if (!this._playingSound) return
    this._playingSound.onEnded.off(this.onEnded.emit)
    this._playingSound.stop()
    this._playingSound = null
  }
}

export default class AudioLayeredMusic {
  gain: GainNode
  onEnded: Signal<void> = new Signal()

  tracks: Map<string, LayerTrack> = new Map()

  constructor(readonly engine: AudioEngine) {
    this.gain = engine.context.createGain()
    this.gain.connect(engine.master)
  }

  addTrack(id: string, gain: number = 0) {
    const layer = new LayerTrack(this.engine, id)
    layer.gain.gain.value = gain
    layer.gain.connect(this.gain)
    this.tracks.set(id, layer)
  }

  getTrack(id: string): LayerTrack {
    return this.tracks.get(id)
  }

  play(opts: PlayOptions) {
    this.tracks.forEach((layer) => layer.play(opts))
    return this
  }

  stop() {
    this.tracks.forEach((layer) => layer.stop())
  }

  dispose(): void {
    this.stop()
  }
}
